<template>
  <div>
    <div
      class="text-caption mx-3 mt-n5 text-right"
      v-html="markdownHint"
    />
    <v-textarea
      v-model="localValue"
      dense
      outlined
      :rows="3"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'

  const markdownHint = 'You can use <a href="https://guides.github.com/features/mastering-markdown/" rel="noopener" target="_blank" tabindex="-1">markdown</a>'

  export default {
    name: 'FormTextarea',
    mixins: [StringValue, RequiredRules],
    data () {
      return {
        markdownHint,
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
